import React, { useEffect,useState} from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Bread from '../component/Breadcrumbs';
import Sidebar from '../component/Sidebar';
import Datatable from '../component/Datatable';
import {UserList} from '../Services/User';
import {AuthData} from '../Services/Authdata';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
// import Swal from 'sweetalert2';
// import {Link} from 'react-router-dom';
import MaterialIcons from '../component/MaterialIcons';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));


export default function Transaction() {

  const calc = (num) => {
    num = num.toString(); //If it's not already a String
    num = num.slice(0, (num.indexOf("."))+3); //With 3 exposing the hundredths place
    return Number(num); //If you need it back as a Number

  }
    const br = [{
        'title':'Transaction',
        'icon':"",
        'url':'/transaction'
    }];
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [bopen, setBopen] = React.useState(false)
    const [open, setOpen] = useState(false);
    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: 'selection',
    }
    const handleSelect = (date) => {
        setBopen(true);
        setStartDate(date.selection.startDate);
        setEndDate(date.selection.endDate)
        UserList('transaction/list?startDate='+date.selection.startDate+'&endDate='+date.selection.endDate,'GET',AuthData().token).then((result)=>{
          setData(result.data);
          setBopen(false);
        })
    }
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [srow, setSrow] = useState([]);
  useEffect(() =>{
    UserList('transaction/list','GET',AuthData().token).then((result)=>{
      setData(result.data);
    })
  },[])
  const columns = [
    {
        name: "userName",
        label: "Customer",
        options: {
            filter: true,
            sort: true,
            searchable:true,
            customBodyRenderLite:(value, dataIndex,updateValue) => {
                return <span style={{display:'flex'}}>
                <Avatar title={data[dataIndex].userName} alt={data[dataIndex].userName} src={data[dataIndex].profilePic} />
                <h4 style={{marginTop:"10px"}}>{data[dataIndex].userNname}</h4>
                </span>
            }
        }
    },
    {
     name: "orderId",
     label: "Order Id",
     options: {
      filter: true,
      sort: true,
     }
    },
    {
     name: "provider",
     label: "Order Type",
     options: {
      filter: true,
      sort: true,
     }
    },
     {
      name: "bookingId",
      label: "Booking Id",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "bookingStatus",
      label: "Booking Status",
      options: {
       filter: true,
       sort: true,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
        return data[dataIndex].bookingStatus === 'CancellationInProgress' ? 'CANCELLED' : data[dataIndex].bookingStatus;
      }
      }
     },
     {
      name: "totalAmount",
      label: "Total Amount",
      options: {
       filter: true,
       sort: true,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
          var totalAmount = data[dataIndex].totalAmount;
          return calc(totalAmount);
        }
      }
     },
     {
      name: "tax",
      label: "Taxes",
      options: {
       filter: true,
       sort: true,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
        return calc(data[dataIndex].tax);
        }
      }
     },
     {
      name: "commission",
      label: "Commission",
      options: {
       filter: true,
       sort: true,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
        return calc(data[dataIndex].commission);
        }
      }
     },
     {
      name: "amount",
      label: "Fare",
      options: {
       filter: true,
       sort: true,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
        return calc(data[dataIndex].amount);
        }
      }
     },
     {
      name: "refund",
      label: "Refunds",
      options: {
       filter: true,
       sort: true,
       customBodyRenderLite:(value, dataIndex,updateValue) => {
        return calc(data[dataIndex].refund);
        }
      }
     },
     {
      name: "paymentStatus",
      label: "Payment Status",
      options: {
       filter: true,
       sort: true,
      }
     },{
      name: "createdAt",
      label: "createdAt",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "orderId",
      label: "Invoice",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
          var orderId = data[dataIndex].orderId;
            return (
            <div onClick={(e)=>{window.location.replace(process.env.REACT_APP_BASEAPI_URL+'booking/invoice/'+orderId)}} style={{cursor:"pointer"}}>
                <MaterialIcons color="secondary" icon="download" size={20} />
            </div>);
          }
        }
     },
   ];
  const options = {
    filterType: 'dropdown',
    selectableRowsOnClick:false,
    responsive: "standard",
    serverSide: true,
    confirmFilters:true,
    search:true,
    onRowSelectionChange:(currentRowsSelected, allRowsSelected, rowsSelected) => {
       const abc = rowsSelected.map((r)=>{
         return data[r].id;
       })
        setSrow(abc);
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
        return (
          <div style={{ marginTop: '40px' }}>
            <DateRange
                ranges={[selectionRange]}
                onChange={handleSelect}
                showDateDisplay={false}
                editableDateInputs={true}
                open={false}
            />
          </div>
        );
      },
    customToolbarSelect:(selectedRows, displayData, setSelectedRows) =>{
    },
  };

  return (
    <div className={classes.root}>
      <Backdrop className={classes.backdrop} open={bopen}>
          <CircularProgress color="inherit" />
      </Backdrop>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br}/>
        <h1>Transaction</h1>
       <Datatable
        title="Transactions" 
        data={data}
        columns={columns}
        options={options}
        />
      </main>
    </div>
    
   
  );
}


// WEBPACK FOOTER //
// ./src/Pages/Transaction.js